<img hisImage="telephone" alt="{{'cm.stu.phone'|hisUi}}" title="{{'cm.stu.phone'|hisUi}}" class="inlineicon">
<a [href]="url">{{value}}</a>
